import React from "react";

const ColabCard = ({ name, url, icon, color, backgroundImage }) => {
  return (
    <a
      href={url}
      className={`colab-card${backgroundImage ? ' colab-card--bg' : ''}`}
      target="_blank"
      rel="noopener noreferrer"
      style={backgroundImage ? {
        backgroundImage: `url(${backgroundImage})`,
      } : {}}
    >
      {!backgroundImage && (
        <div className="colab-content">
          <span className="colab-icon">{icon}</span>
          <span className="colab-name">{name}</span>
        </div>
      )}
    </a>
  );
};

export default ColabCard;
